export enum Source {
    PROSPECT_SEARCH = 'PROSPECT_SEARCH',
    FILE_IMPORT = 'FILE_IMPORT',
}
